<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Document Verification</h1>
            <button class="page-btn" (click)="callDispute(1)">Apply for Verification</button>
            <div class="content-wrap">
                <div class="table-responsive">
                    <table class="ui celled table hover" [dtTrigger]="dtTrigger" datatable [dtOptions]="dtOptions">
                        <thead>
                            <tr>
                                <th *ngIf="hideId">Id</th>
                                <th>Application Id</th>
                                <th>Full Name</th>
                                <th>Seat No.</th>                               
                                <th>Passing Year</th>
                                <th>Stream</th>
                                <th>Branch</th>
                                <th>Semester</th>
                                <th>Document</th>
                                <th>Status</th>
                                <th>Action</th>
                                <th hidden>date</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let data of request">
                                <td *ngIf="hideId">{{data.id}}</td>
                                <td>{{data.application_id}}</td>
                                <td>{{data.first_name}} {{data.last_name}}</td>
                                <td>{{data.enroll_no}}</td>
                                <td>{{data.monthOfPassing}}/{{data.year}}</td>
                                <td>{{data.stream_name}}</td>
                                <td>{{data.branch_nm}}</td>
                                <td>{{data.semester}}</td>
                                <!-- <td>{{data.id}}</td> -->
                                <td>{{data.doc_name}}</td>
                                <!-- <td>{{data.doc_status}}</td> -->
                                <td
                                    *ngIf="data.doc_status=='Rejected'||data.doc_status=='Approved_Fail'||data.doc_status=='Approved_Pass' ||data.doc_status=='Approved' || data.doc_status=='SV_Approved' || data.doc_status=='SV_Approved_Pass' || data.doc_status=='SV_Approved_Fail'  || data.doc_status=='SV_Rejected' ||data.doc_status=='Requested' || data.doc_status=='Unable To Verify'|| data.doc_status=='Offline'|| data.doc_status=='SV_Unable To Verify'|| data.doc_status=='SV_Offline' || data.doc_status=='Ver_Request_Edit' || data.doc_status=='Uni_Request_Edit' ">
                                    Open
                                </td>
                                <td
                                    *ngIf="data.doc_status=='UN_Approved'||data.doc_status=='UN_Approved_Pass' ||data.doc_status=='UN_Approved_Fail' ||data.doc_status=='UN_Rejected' || data.doc_status=='Uni_Auto_Approved'|| data.doc_status=='Uni_Auto_Rejected'|| data.doc_status=='SVD_Rejected'|| data.doc_status=='SVD_Approved'  || data.doc_status=='SVD_Approved_Pass'|| data.doc_status=='SVD_Approved_Fail'">
                                    Closed
                                </td>
                                <td>
                                    <button class='action-btn bg-theme' (click)="downloadPDF(data.application_id)"><i
                                            class="fa fa-download download-icon" aria-hidden="true"></i>
                                        Download</button>

                                        <button class='action-btn bg-theme ml-2' (click)="downloadCertificate(data.id,data.doc_status)" 
                                        *ngIf="data.doc_status=='UN_Approved_Pass' ||data.doc_status=='UN_Approved_Fail' ||data.doc_status=='UN_Rejected' || data.doc_status=='Uni_Auto_Approved'|| data.doc_status=='Uni_Auto_Rejected'|| data.doc_status=='SVD_Rejected'|| data.doc_status=='SVD_Approved'  || data.doc_status=='SVD_Approved_Pass'|| data.doc_status=='SVD_Approved_Fail'"> 
                                            <i class="fa fa-download download-icon" aria-hidden="true" ></i>Download Certificate</button>
                                            
                                        <button class="action-btn bg-grey ml-2" *ngIf=" data.doc_status=='Ver_Request_Edit' || data.doc_status=='Uni_Request_Edit'" (click)="editVerification(data.id, 4)">Edit</button>
                                </td>
                                <td hidden>{{data.req_date}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <p class="dispute-link color-theme"><a (click)="callDispute(2)">Raise Dispute</a></p>
            </div>
            
        </div>
    </div>
</div>